module.exports = __webpack_public_path__ + "img/banner_AboutUs4_Mobile.019f900f.png";